<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import AdminItem from '@/components/mobile/telegram/settings_components/admin_components/AdminItem.vue';
import PopUpModal from '@/components/mobile/telegram/modal_components/SelectUserRole.vue';
import User from '@/models/user';
import { getUsers } from '@/composables/userWorker'; 
import { setBackButton, hideBackButton } from '@/tools/setTelegramButtons';
import AnimatePlaceHolder from '@/components/mobile/telegram/AnimatePlaceHolder.vue';

const admins = ref();
const editworker = ref();
const adminToEdit = ref<User | null>(null);
const openPopAddAdmin = ref(false);
const adminsIsResieved = ref<boolean>(false);

async function getAdmins() {
  admins.value = await getUsers();
  adminsIsResieved.value = true;
}

onMounted(async () => {
  setBackButton();
  await getAdmins();
})

onUnmounted(() => {
  hideBackButton();
});


function openPop(){
  openPopAddAdmin.value = true;
}

async function closePop() {
  openPopAddAdmin.value = false;
  editworker.value = false;
  adminsIsResieved.value = false
  await getAdmins();
}

function openEditAdmin(admin_telegram_id: number) {
  adminToEdit.value = admins.value.find((admin: { telegram_id: number; }) => admin.telegram_id == admin_telegram_id);
  editworker.value = true;
  openPopAddAdmin.value = true;
}

</script>

<template>
  <Transition name="fade">
    <div class="background-blur-choose-point" v-if="openPopAddAdmin" @click="closePop()"></div>
  </Transition>
  <Transition name="slideUp">
    <PopUpModal v-if="openPopAddAdmin"
      @close="closePop"
      :editworker="editworker"
      :adminToEdit="adminToEdit"
    />
  </Transition>
  <div class="admin-section">
    <div class="admin-label">
      Сотрудники
    </div>
    <div class="admins-body" v-if="adminsIsResieved">
      <AdminItem v-for="(admin, index) in admins"
        :admin="admin"
        :isFirst="index == 0"
        :isLast="index === admins.length - 1"
        :adminsIsResieved="adminsIsResieved"
        @openEditAdmin="openEditAdmin"
      />
    </div>
    <div class="add-admin-wrapper" @click="openPop()" v-if="adminsIsResieved">
      <img src="@/assets/admin-plus.svg">
      <p class="add-admin-text">Добавить</p>
    </div>
    <AnimatePlaceHolder v-else
      width="100%"
      height="75vh"
      border-radius="var(--border-radius)"
      style="margin-top: 20px;"
    />
  </div>
</template>

<style scoped>

.background-blur-choose-point {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  background-color: #8E8E9290;
  backdrop-filter: blur(10px);
}

.btn:active {
  transform: var(--transform-scale-active);
}

.all-items-btn:active {
  transform: var(--transform-scale-active);
}

.btn-settings:active {
  transform: var(--transform-scale-active);
}

.btn {
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  background: none;
  font-family: inherit;
  background-color: var(--orange-color);
  font-size: 18px;
  font-weight: 600;
  color: white;
  border-radius: var(--border-radius);
  width: 100%;
  height: 40px;
  align-items: center;
  display: flex;
  justify-content: center;
  transition: all .3s ease;
}

.add-admin-text{
  font-size: 16px;
  font-weight: 400;
}

.add-admin-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 20px;
  gap: 10px;
  width: 100%;
  border-radius: var(--border-radius);
  margin-top: 10px;
  margin-bottom: 130px;
  box-sizing: border-box;
  box-shadow: var(--drop-shadow-item);
}

.admins-body{
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  border-radius: var(--border-radius);
  margin-top: 20px;
}

.label-section{
  font-size: 18px;
  font-weight: 500;
  text-align: start;
}

.admin-section{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.admin-label {
  width: 100%;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
}

</style>
